import tariffsManager from 'pages/landing/landingConstructor/tariffs/tariffsManager/tariffsManager'

/** Возвращает булево значение видима ли панель с настройками активного тарифа */
export function useIsPanelVisible() {
	const { activeTariffId, isPanelOpen } = tariffsManager.store

	return !!activeTariffId && isPanelOpen
}
